(function () {
  'use strict';

  var root = document.querySelector('[data-confirm-order]');
  if (!root) return;

  var form = root.querySelector('[data-confirm-form]');
  if (!form) return;

  var summaryItems = root.querySelector('[data-summary-items]');
  var summaryTotal = root.querySelector('[data-summary-total]');
  var summaryCount = root.querySelector('[data-summary-count]');
  var errorEl = root.querySelector('[data-form-error]');
  var submit = root.querySelector('.zenoa-confirm__submit');
  var submitLabel = root.querySelector('[data-submit-label]');
  var advancePanel = root.querySelector('[data-advance-panel]');
  var proofPanel = root.querySelector('[data-proof-panel]');
  var proofInput = root.querySelector('[data-proof-input]');
  var proofPreview = root.querySelector('[data-proof-preview]');
  var proofImage = root.querySelector('[data-proof-image]');
  var proofName = root.querySelector('[data-proof-name]');
  var proofStatus = root.querySelector('[data-proof-status]');
  var proofFileNameField = root.querySelector('[data-proof-file-name]');
  var removeProofBtn = root.querySelector('[data-remove-proof]');
  var shareProofBtn = root.querySelector('[data-share-proof]');
  var whatsappNumber = root.dataset.whatsapp || '923197312660';
  var selectedProofFile = null;

  var routes = window.routes || {};
  var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : (routes.root_url || '/');
  var cartPath = routes.cart_url || (rootPath.replace(/\/$/, '/') + 'cart');
  var emptyCollectionUrl = routes.all_products_collection_url || (rootPath.replace(/\/$/, '/') + 'collections/all');
  var bundleDiscountCode = '';

  function getCartUrl() {
    return rootPath.replace(/\/$/, '/') + 'cart.js';
  }

  function getCartUpdateUrl() {
    return rootPath.replace(/\/$/, '/') + 'cart/update.js';
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
      return Shopify.formatMoney(value, Shopify.money_format);
    }
    var currency = document.documentElement.dataset.currency || 'PKR';
    return (value / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: 0
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char];
    });
  }

  async function getCart() {
    var response = await fetch(getCartUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to load your shopping bag.');
    }

    return response.json();
  }

  async function updateCartData(attributes) {
    var body = new FormData();

    Object.keys(attributes).forEach(function (key) {
      var value = attributes[key];

      body.append(
        'attributes[' + key + ']',
        value === undefined || value === null || String(value) === ''
          ? 'N/A'
          : String(value)
      );
    });

    var response = await fetch(getCartUpdateUrl(), {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      var errorPayload = await response.json().catch(function () {
        return {};
      });

      throw new Error(
        errorPayload.description || 'Unable to save your order details.'
      );
    }

    return response.json();
  }

  function renderSummary(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      summaryCount.textContent = '0 items';

      summaryItems.innerHTML =
        '<p class="zenoa-confirm__empty">Your shopping bag is empty. <a href="' +
        emptyCollectionUrl +
        '">Explore products</a>.</p>';

      summaryTotal.textContent = formatMoney(0);

      if (submit) submit.disabled = true;
      return;
    }

    summaryCount.textContent =
      cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    summaryItems.innerHTML =
      '<div class="zenoa-confirm__summary-items">' +
      cart.items
        .map(function (item) {
          var image = item.image || '';
          var variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? item.variant_title
              : '';

          return (
            '<article class="zenoa-confirm__item">' +
            '<img src="' +
            escapeHtml(image) +
            '" alt="" width="58" height="68" loading="lazy">' +
            '<div>' +
            '<div class="zenoa-confirm__item-name">' +
            escapeHtml(item.product_title) +
            '</div>' +
            '<div class="zenoa-confirm__item-meta">' +
            (variant ? escapeHtml(variant) + ' · ' : '') +
            'Qty ' +
            item.quantity +
            '</div>' +
            '</div>' +
            '<strong class="zenoa-confirm__item-price">' +
            formatMoney(item.final_line_price) +
            '</strong>' +
            '</article>'
          );
        })
        .join('') +
      '</div>';

    summaryTotal.textContent = formatMoney(cart.total_price);

    if (submit) submit.disabled = false;
  }

  function field(name) {
    var el = form.elements[name];
    return el ? String(el.value || '').trim() : '';
  }

  function selectedValue(name) {
    var el = form.querySelector(
      'input[name="' + name + '"]:checked'
    );

    return el ? String(el.value || '').trim() : '';
  }

  function setError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function setHidden(el, hidden) {
    if (!el) return;

    el.hidden = hidden;
    el.setAttribute(
      'aria-hidden',
      hidden ? 'true' : 'false'
    );
  }

  function currentAdvanceMethod() {
    return selectedValue('advance_method');
  }

  function methodNeedsProof() {
    var checked = form.querySelector('input[name="advance_method"]:checked');
    return !!checked && checked.dataset.needsProof === 'true';
  }

  function syncPaymentUI() {
    var preference = selectedValue('payment_method');
    var isAdvance = preference === 'Advance Payment';

    setHidden(advancePanel, !isAdvance);

    root
      .querySelectorAll('.zenoa-confirm__payment')
      .forEach(function (card) {
        var input = card.querySelector(
          'input[name="payment_method"]'
        );

        card.classList.toggle(
          'is-selected',
          !!input && input.checked
        );
      });

    var advance = currentAdvanceMethod();

    root
      .querySelectorAll('.zenoa-confirm__method')
      .forEach(function (card) {
        var input = card.querySelector(
          'input[name="advance_method"]'
        );

        card.classList.toggle(
          'is-selected',
          !!input && input.checked
        );
      });

    root
      .querySelectorAll('[data-method-panel]')
      .forEach(function (panel) {
        setHidden(
          panel,
          !isAdvance || panel.dataset.methodPanel !== advance
        );
      });

    setHidden(proofPanel, !(isAdvance && methodNeedsProof()));

    if (submitLabel) {
      submitLabel.textContent = isAdvance
        ? 'Continue to advance payment checkout'
        : 'Continue to secure checkout';
    }
  }

  function splitName(fullName) {
    var parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    var firstName = parts.shift() || '';
    var lastName = parts.join(' ');

    return {
      firstName: firstName,
      lastName: lastName
    };
  }

  form
    .querySelectorAll(
      'input[name="payment_method"], input[name="advance_method"]'
    )
    .forEach(function (input) {
      input.addEventListener('change', function () {
        clearError();
        syncPaymentUI();
      });
    });

  if (proofInput) {
    proofInput.addEventListener('change', function () {
      var file = proofInput.files && proofInput.files[0];
      if (!file) return;

      selectedProofFile = file;

      var reader = new FileReader();
      reader.onload = function (e) {
        if (proofImage) proofImage.src = e.target.result;
        setHidden(proofPreview, false);
      };
      reader.readAsDataURL(file);

      if (proofName) proofName.textContent = file.name;
      if (proofStatus) proofStatus.textContent = 'Selected locally — not uploaded automatically.';
      if (proofFileNameField) proofFileNameField.value = file.name;
      if (shareProofBtn) setHidden(shareProofBtn, false);
      clearError();
    });
  }

  if (removeProofBtn) {
    removeProofBtn.addEventListener('click', function () {
      selectedProofFile = null;
      if (proofInput) proofInput.value = '';
      if (proofFileNameField) proofFileNameField.value = '';
      setHidden(proofPreview, true);
      if (shareProofBtn) setHidden(shareProofBtn, true);
    });
  }

  if (shareProofBtn) {
    shareProofBtn.addEventListener('click', function () {
      var text = encodeURIComponent(
        'Hi Zenoa, main apna payment screenshot is order ke liye bhej raha/rahi hoon.'
      );
      window.open('https://wa.me/' + whatsappNumber + '?text=' + text, '_blank');
    });
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    clearError();
    syncPaymentUI();

    if (!form.reportValidity()) return;

    var fullName = field('full_name');
    var phone = field('phone')
      .replace(/\s+/g, ' ')
      .trim();

    var address = field('address1');
    var city = field('city');
    var landmark = field('landmark');
    var preference = selectedValue('payment_method');

    var advanceMethod =
      preference === 'Advance Payment'
        ? currentAdvanceMethod()
        : '';

    if (fullName.length < 2) {
      setError('Please enter your full name.');
      form.elements.full_name.focus();
      return;
    }

    if (phone.replace(/\D/g, '').length < 7) {
      setError('Please enter a valid phone / WhatsApp number.');
      form.elements.phone.focus();
      return;
    }

    if (address.length < 8) {
      setError('Please enter your complete delivery address.');
      form.elements.address1.focus();
      return;
    }

    if (city.length < 2) {
      setError('Please enter your city.');
      form.elements.city.focus();
      return;
    }

    if (
      preference === 'Advance Payment' &&
      !advanceMethod
    ) {
      setError('Please select an advance payment method.');
      return;
    }

    if (
      preference === 'Advance Payment' &&
      methodNeedsProof() &&
      !selectedProofFile
    ) {
      setError('Please attach your payment screenshot — orders without proof will be cancelled.');
      if (proofInput) proofInput.focus();
      return;
    }

    submit.disabled = true;
    submitLabel.textContent = 'Preparing your checkout…';

    try {
      var cart = await getCart();

      if (!cart.items || !cart.items.length) {
        throw new Error(
          'Your shopping bag is empty. Add a product before continuing.'
        );
      }

      var names = splitName(fullName);
      var paymentReference = field('payment_reference');

      var attributes = {
        '__Zenoa Form version': '2026-09-lite',
        '__Zenoa Full name': fullName,
        '__Zenoa Contact phone': phone,
        '__Zenoa City': city,
        '__Zenoa Landmark': landmark,
        '__Zenoa Payment preference':
          preference || 'N/A',
        '__Zenoa Advance payment method':
          advanceMethod || 'N/A',
        '__Zenoa Payment reference':
          paymentReference || 'N/A',
        '__Zenoa Payment proof file':
          selectedProofFile ? selectedProofFile.name : 'N/A',
        '__Zenoa Customer details confirmed': 'Yes'
      };

      try {
        var bundleActive =
          sessionStorage.getItem('zenoaBundleActive');

        bundleDiscountCode =
          sessionStorage.getItem(
            'zenoaBundleDiscountCode'
          ) || '';

        if (bundleActive === 'yes') {
          attributes['Order type'] =
            'Complete Home Set bundle';

          if (bundleDiscountCode) {
            attributes['Bundle discount code'] =
              bundleDiscountCode;
          }
        }

        sessionStorage.removeItem('zenoaBundleActive');
        sessionStorage.removeItem(
          'zenoaBundleDiscountCode'
        );
      } catch (_) {}

      await updateCartData(attributes);

      var params = new URLSearchParams();

      params.set(
        'checkout[shipping_address][first_name]',
        names.firstName
      );

      if (names.lastName) {
        params.set(
          'checkout[shipping_address][last_name]',
          names.lastName
        );
      }

      params.set(
        'checkout[shipping_address][address1]',
        address
      );

      if (landmark) {
        params.set(
          'checkout[shipping_address][address2]',
          landmark
        );
      }

      params.set(
        'checkout[shipping_address][city]',
        city
      );

      params.set(
        'checkout[shipping_address][country]',
        'Pakistan'
      );

      params.set(
        'checkout[shipping_address][phone]',
        phone
      );

      Object.keys(attributes).forEach(function (key) {
        params.set(
          'attributes[' + key + ']',
          attributes[key]
        );
      });

      if (bundleDiscountCode) {
        params.set(
          'discount',
          bundleDiscountCode
        );
      }

      var cleanCartPath = cartPath
        .replace(/\.js$/, '')
        .replace(/\/$/, '');

      if (!/\/cart$/.test(cleanCartPath)) {
        cleanCartPath += '/cart';
      }

      var checkoutBase =
        cleanCartPath +
        '/' +
        cart.items
          .map(function (item) {
            return (
              String(item.variant_id) +
              ':' +
              String(item.quantity)
            );
          })
          .join(',');

      window.location.assign(
        checkoutBase +
        (params.toString()
          ? '?' + params.toString()
          : '')
      );
    } catch (error) {
      setError(
        error && error.message
          ? error.message
          : 'We could not prepare checkout. Please try again.'
      );

      submit.disabled = false;
      syncPaymentUI();
    }
  });

  syncPaymentUI();

  getCart()
    .then(renderSummary)
    .catch(function () {
      setError(
        'We could not load your shopping bag. Please go back to the cart and try again.'
      );
    });
})();